import { ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "3xs-v4",
            "2xs-v4",
            "xs-v4",
            "s-v4",
            "m-v4",
            "l-v4",
            "xl-v4",
            "2xl-v4",
            "3xl-v4",
            "heading-1",
            "heading-2",
            "code-xs",
            "code-sm",
          ],
        },
      ],
      tracking: [{ tracking: ["heading"] }],
      "font-weight": [
        {
          font: [
            "semimedium",
            "light-v4",
            "normal-v4",
            "medium-v4",
            "semibold-v4",
            "bold-v4",
          ],
        },
      ],
      "font-family": [
        { font: ["family-inter", "family-mono", "sans-v4", "mono-v4"] },
      ],
      // Register every custom boxShadow name from tailwind.config.js so
      // shadow utilities conflict-merge with each other and with the stock
      // scale (shadow-sm etc.) instead of both being emitted.
      shadow: [
        {
          shadow: ["border", "default", "large", "extra-large"],
        },
      ],
      ease: [{ ease: ["bezier"] }],
    },
    // The custom 8px radius step (tailwind.config.js) so rounded-md-2 and its
    // corner variants (rounded-t-md-2 …) conflict-merge with the other radii.
    theme: { borderRadius: ["md-2"] },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
